import { ArrowRight } from "@untitledui/icons"
import type { IntakeBestTime, IntakeContactChannel } from "@/lib/api/public-consumer"
import { ChipGroup, type ChipOption } from "./chips"
import { FlowCta, FlowHeading, PhasePane } from "./flow-chrome"
import { CONSUMER_V2 } from "./copy"

// The last extra — how the shop should reach out. Its CTA is the extras
// finisher: "That's everything →" re-sends the full details blob (idempotent)
// with extrasDoneAt and hands over to the reveal.

const C = CONSUMER_V2.extras.reach

const CHANNELS: readonly ChipOption<IntakeContactChannel>[] = [
  { value: "text", label: "Text" },
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
]

const BEST_TIMES: readonly ChipOption<IntakeBestTime>[] = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
  { value: "anytime", label: "Anytime" },
]

export function StepReach({
  shopName,
  contactPref,
  setContactPref,
  onDone,
}: {
  shopName: string
  contactPref: { channel: IntakeContactChannel | null; bestTime: IntakeBestTime | null }
  setContactPref: (
    patch: Partial<{ channel: IntakeContactChannel | null; bestTime: IntakeBestTime | null }>,
  ) => void
  onDone: () => void
}) {
  return (
    <PhasePane>
      <header className="mt-5">
        <FlowHeading className="text-[28px] font-bold leading-[1.15] tracking-tight text-ink">
          {C.title(shopName)}
        </FlowHeading>
      </header>

      <div className="mt-5 flex-1 lg:pointer-fine:flex-none space-y-6">
        <ChipGroup
          label={C.channelLabel}
          options={CHANNELS}
          value={contactPref.channel ?? "text"}
          onChange={(channel) => setContactPref({ channel: channel ?? "text" })}
        />
        <ChipGroup
          label={C.bestTimeLabel}
          options={BEST_TIMES}
          value={contactPref.bestTime}
          onChange={(bestTime) => setContactPref({ bestTime })}
        />
      </div>

      <div className="mt-6">
        <FlowCta onClick={onDone}>
          {C.cta}
          <ArrowRight className="size-4" aria-hidden />
        </FlowCta>
      </div>
    </PhasePane>
  )
}
